module.exports = __webpack_public_path__ + "31f430c77e7b6d7ff8defe2c4a130154.pdf";